import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { loginAdmin, verifyLoginAdmin } from '../../api/authApi';
import { useAuthStore } from '../../stores/authStore';
import Notification from '../../components/Notification';

import logo from '../../assets/images/logo.png';
import '../../assets/css/Login.css';

const VerifyEmail = () => {
  const location = useLocation();
  const { email, password, rememberMe } = location.state || {};
  const inputRefs = useRef([]);
  const setAdmin = useAuthStore((state) => state.setAdmin);
  const [code, setCode] = useState(['', '', '', '']);
  const [timer, setTimer] = useState(30);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [isResendLoader, setResendLoader] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');


  useEffect(() => {
    let interval;
    if (timer > 0) {
      setIsResendEnabled(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setIsResendEnabled(true);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [timer]);

  const handleChangeText = (index, value) => {
    if (value?.length > 1) {
      const newValues = value?.split('')?.slice(0, 4);
      setCode(newValues);
      inputRefs.current[Math?.min(3, index + newValues?.length)]?.focus();
      return;
    }

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    if (value !== '' && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleResendVerification = async () => {

    if (!isResendEnabled) return;
    setIsResendEnabled(false);
    setResendLoader(true);

    try {
      const res = await loginAdmin({ email, password });
      if (!res?.status && res?.status !== undefined) {
        setError('Something went wrong. Please try again.')
        setResendLoader(false);
      } else {
        setCode(['', '', '', '']);
        setTimer(30);
        setShowNotification(true);
        setNotificationMessage('Code sent! Check your inbox for email.');
        setTimeout(() => {
          setShowNotification(false);
        }, 8000);
        setIsResendEnabled(true);
        setResendLoader(false);
      }
    } catch (error) {
      console.log(error)
      setIsResendEnabled(true);
      setResendLoader(false);
    }

  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const codeString = code?.join('');
    if (codeString?.length < 4 || code?.some((d) => d?.trim() === '')) {
      setError('Please enter the full 4-digit verification code.');
      return;
    }
    try {
      setIsLoading(true);
      const res = await verifyLoginAdmin({
        email,
        otp: codeString
      });
      const userData = {
        adminId: res?.adminId,
        email: res?.email,
        name: res?.name,
        lastName: res?.lastName,
        profileImg: res?.profileImg
      };
      if (!res?.status && res?.status !== undefined) {
        setError(res?.message);
        setIsLoading(false);
      } else {
        setAdmin(res);
        if (rememberMe) {
          const expiryDate = new Date();
          expiryDate.setDate(expiryDate.getDate() + 30);

          Cookies.set('rememberMe', true, { expires: 30 });
          Cookies.set('admin_token', res?.token, { expires: 30 });

          const userDataWithExpiry = {
            ...userData,
            expiry: expiryDate.toISOString()
          };
          Cookies.set('userData', JSON.stringify(userDataWithExpiry), { expires: 30 });
        } else {
          Cookies.set('rememberMe', true);
          Cookies.set('admin_token', res?.token)
          Cookies.set('userData', JSON.stringify(userData));
        }
        setIsLoading(false);
        window.location.href = '/dashboard';
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }

  return (
    <form className="form-design verify-popup" onSubmit={handleSubmit} autoComplete="off">
      <section className="login">
        <div className="loginWindow">
          <div className="loginModel">
            <img src={logo} alt="Login" />
            <p className="loginTitle">Check your email</p>
            <p className="verify-subtitle">We've sent you an email with a 4-digit code - please enter it below to sign in</p>

            <div className="name-field otp-field">
              {code?.map((digit, index) => (

                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d?$/.test(value)) {
                      handleChangeText(index, value);
                      setError('');
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && code[index] === "") {
                      if (index > 0) {
                        inputRefs.current[index - 1]?.focus();
                        const newCode = [...code];
                        newCode[index - 1] = "";
                        setCode(newCode);
                      }
                    }
                    if (
                      !/[0-9]/?.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "ArrowLeft" &&
                      e.key !== "ArrowRight" &&
                      e.key !== "Tab" &&
                      e.key !== "Enter" &&
                      e.key !== "Ctrl" &&
                      e.key !== "v" &&
                      e.key !== "V"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedOtp = e.clipboardData.getData("text")?.slice(0, 4);
                    if (!/^\d+$/?.test(pastedOtp)) return;
                    const pasteArray = pastedOtp?.split("");
                    const newCode = [...code];
                    for (let i = 0; i < 4; i++) {
                      newCode[i] = pasteArray[i] || "";
                    }
                    setCode(newCode);
                    inputRefs.current[Math?.min(pasteArray?.length - 1, 3)]?.focus();
                  }}
                  placeholder="0"
                  className="otp-input"
                />

              ))}
            </div>
            {error && <p className="error-message verify-error-messsage">{error}</p>}
            <div className="verify-button-wrap">
              <button
                className={`verifyButton primary-button button ${isLoading ? 'btn_loading' : ''
                  }`}
                type="submit"
              >
                {isLoading ? (
                  <div className="registerLoader">
                    <div className="ring-loader"></div>
                  </div>
                ) : (
                  `Verify it's me`
                )}
              </button>
            </div>

            <p className="verify-subtitle verify-resend-subtitle">Didn’t get the email? Check your spam folder or{' '}
              <span className="resend-otp-btn" onClick={() => { handleResendVerification() }}>resend verification
                {!isResendEnabled && !isResendLoader && timer > 0 &&
                  `(${timer}s)`
                }.
              </span>
              {isResendLoader &&
                <div className="resendLoader">
                  <div className="resend-ring-loader"></div>
                </div>
              }

            </p>
          </div>

        </div>
        <div className="pvivacy_mobile">
          <p>
            © Ivycorn {new Date().getFullYear()}. All Rights Reserved.{' '}
            <span>Terms of Service</span> & <span>Privacy Policy</span>.
          </p>
        </div>
      </section>
      {showNotification && (
        <Notification
          showNotification={showNotification}
          notificationMessage={notificationMessage}
          setShowNotification={setShowNotification}
        />
      )}
    </form>
  );
}
export default VerifyEmail;